<template>
  <w-dialog :dialog-show="state" @handleClose="handleClose" :top="30">
    <div class="content" slot="content">
      <p class="header flex-between">
        <span class="header-title">{{ title }}</span>
        <span class="iconfont iconx" @click="handleClose"/>
      </p>
      <div class="middle">
        <input v-model="sectionName" type="text" placeholder="请输入模块名称" :maxlength="maxLength" @blur="onBlur">
        <span class="text-total">{{ num }}/{{ maxLength }}</span>
      </div>
      <div class="content-flex" v-if="moduleTitles.length > 0">
        <div v-for="(item, index) in moduleTitles" :class="['select-item', item === sectionName ? 'active' : '']" :key="index" @click="selectItem(item)">
          {{ item }}
        </div>
      </div>
      <div class="theme-button flex-center footer-btn" @click="change">确认</div>
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from '@/components/global/w-dialog'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { envMixin } from '@/assets/js/mixin/global'
	import { mapActions, mapState } from 'vuex'

	export default {
		name: 'change-module-name',
		mixins: [ componentsMixin, envMixin ],
		props: {
			title: {
				type: String,
				default: '修改模块名称'
			},
			state: {
				type: Boolean,
				default: false
			},
			moduleName: {
				type: String,
				default: ''
			},
			sectionInfo: {
				type: Object,
				default: null
			},
      moduleTitles: {
			  type: Array,
        default: []
      }
		},
		data () {
			return {
				sectionName: this.moduleName,
			}
		},
		mounted () {
		},
		computed: {
			...mapState('cv', [ 'cv' ]),
			num () {
				return this.sectionName.length || 0
			},
			maxLength () {
				let { basic_info: { lang } } = this.cv
				return lang === 'cn' ? 15 : 49
			}
		},
		watch: {
			state (val) {
				if (val) {
					this.sectionName = this.moduleName
				}
			}
		},
		components: {
			WDialog
		},
		methods: {
			...mapActions('cv', [ 'updateCvDetail' ]),
      selectItem(item) {
        this.sectionName = item
      },
			onBlur () {
				if (this.isIos) window.scrollTo(0, 0)
			},
			handleClose () {
				this.$emit('handleClose')
			},
			async change () {
				let { token } = this.$route.params
				let { titleInfo } = this.sectionInfo
				let { mentor_id } = this.cv.basic_info
				let payload = {
					operation_type: 'update_submodule_info',
					submodule_info: {}
				}

				if (titleInfo.id) {
					await this.$api.cv.updateCustomTitle(titleInfo.id, {
						section_title: this.sectionName,
						is_mentor: !!mentor_id
					})
				} else if (titleInfo.type === 'extras') {
					payload.submodule_info.extras_title = this.sectionName
					await this.updateCvDetail({ token, payload })
				} else if (titleInfo.type === 'extras-info') {
          if (this.sectionName.trim().length === 0) {
            this.showToast('名称不能为空')
            return
          }
					payload.submodule_info[`${ titleInfo.field }_title`] = this.sectionName
					let extraInfoResp = await this.updateCvDetail({ token, payload })
          if (extraInfoResp.code === 80120) { // 未找到对应简历
            this.showToast('请编辑简历后再修改')
            return
          }
				} else {
					payload.submodule_info[`${ titleInfo.type }_title`] = this.sectionName
					await this.updateCvDetail({ token, payload })
				}
				this.$emit('refresh', this.sectionName)
				this.handleClose()
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .content {
    width: 80vw;
    height: auto;
    border-radius: 4px;
    padding: 24px;
    background-color: $color-light;
    .header {
      margin-bottom: 24px;
      .header-title {
        color: $color-title;
        font-size: $font-size-large;
        font-weight: 500;
        line-height: 26px;
      }
      .iconx {
        font-size: 18px;
        color: #9c9c9c;
      }
    }
    .middle {
      position: relative;
      //margin-bottom: 20px;
      input {
        height: 40px;
        padding: 0 60px 0 16px;
        border-radius: 2px;
        border: 1px solid #ececec !important;
        font-size: $font-size-medium;
        color: $color-title;
        width: 100%;
        &::placeholder {
          color: #bcbcbc;
        }
      }
      .text-total {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 16px;
        color: #bcbcbc;
        letter-spacing: 0.5px;
      }
    }
    .footer-btn {
      margin-top: 20px;
      height: 38px;
      border-radius: 2px;
      font-size: $font-size-medium-x;
    }
    .content-flex {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .select-item {
        margin-right: 14px;
        margin-top: 10px;
        height: 30px;
        padding: 5px 12px;
        line-height: 18px;
        text-align: center;
        border-radius: 2px;
        border: 1px solid #cfcfcf;
        color: #606060;
        font-size: 14px;
      }
      .active {
        color: #ff6644;
        border-color: #ff6644;
      }
    }
  }
</style>
